import { Link } from 'react-router-dom';
import { formatUnixDateTime } from '@/shared/lib/datetime';
import { DeleteButton } from '@/shared/ui/list/DeleteButton';
import { GenericListPage } from '@/shared/ui/list/GenericListPage';
import type { ListPageConfig, ListRow } from '@/shared/ui/list/types';
import { deleteStories, fetchStoriesList } from './api';

const LIST_KEY = 'publications-stories';

interface Story extends ListRow {
  id: number;
  name?: string;
  preview_image?: { id?: number; thumb_140_140?: string } | null;
  is_accent?: number | boolean;
  is_publish?: number;
  publication_time?: number;
  create_time?: number;
  update_time?: number;
}

const config: ListPageConfig<Story> = {
  queryKey: LIST_KEY,
  title: 'Сторис',
  errorText: 'Ошибка загрузки сторис',
  fetchList: fetchStoriesList,
  rows: ['data'],
  paginated: false,
  columns: [
    {
      header: '№',
      render: (story) => <Link to={`/publications/stories/${story.id}`}>{story.id}</Link>,
    },
    { header: 'Имя', render: (story) => story.name },
    {
      header: 'Превью сторис',
      render: (story) =>
        story.preview_image?.thumb_140_140 && (
          <img src={story.preview_image.thumb_140_140} alt={String(story.preview_image.id ?? '')} />
        ),
    },
    { header: 'Важность', render: (story) => (story.is_accent ? 'Да' : 'Нет') },
    { header: 'Дата публикации', render: (story) => formatUnixDateTime(story.publication_time) },
    { header: 'Дата создания', render: (story) => formatUnixDateTime(story.create_time) },
    { header: 'Дата обновления', render: (story) => formatUnixDateTime(story.update_time) },
    {
      header: 'Опубликовано',
      render: (story) => (story.is_publish === 1 ? 'Опубликованна' : 'Не опубликованна'),
    },
    {
      header: 'Удалить',
      render: (story) => (
        <DeleteButton listKey={LIST_KEY} remove={() => deleteStories(story.id)} />
      ),
    },
  ],
};

export const StoriesPage = () => <GenericListPage config={config} />;
